import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ApiStatus } from "services/common"

const defaultURL = `${process.env.REACT_APP_BASE_API_URL || ""}/rbo/pricing`

export interface UpdatePricingResponse extends AxiosResponse {
  data: {
    apiStatus: ApiStatus
    message: string
  }
}

export interface TaxesDataTypes {
  percentage: number
  taxId: number | null
  appliedOnFees: number[]
  appliedOnRent: boolean
  isAppliedOnCleaningFee: boolean
  isAppliedOnPetFee: boolean
}

export interface UpdatePricingRequestData {
  isFromOnboardingSteps: boolean
  unitId: string
  pmcId: string
  basePrice: number | null
  discount: number | null
  extendedDiscount: number | null
  cleaningFee: number
  cleaningFeeId: number | null
  petFee: number
  petFeeId: number | null
  petFeeType: string
  guestFeeId: number | null
  guestFee: number
  guestFeeType: string
  minimumNonChargeableAdult: number
  maxPetAllowed: number
  taxes: TaxesDataTypes
  isTaxApplied: boolean | null | undefined
  otherFee: number
  otherFeeId: number | null
  otherFeeType: string
}
export interface UpdatePricingRequest extends Partial<AxiosRequestConfig> {
  params: UpdatePricingRequestData
}

export function updatePricing(
  {
    params,
    method = "post",
    url = defaultURL,
    ...config
  }: UpdatePricingRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<UpdatePricingResponse> {
  return axiosInstance({
    method,
    url,
    data: params,
    ...config,
  }) as Promise<UpdatePricingResponse>
}
